let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("izOBN")).then(() => parcelRequire('e88pi'));